import { render, staticRenderFns } from "./sidebarmenu.vue?vue&type=template&id=1efad243&"
import script from "./sidebarmenu.vue?vue&type=script&lang=js&"
export * from "./sidebarmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports